import { z } from 'zod';

/**
 * Hard cap on a member's personal dictation-reformulation prompt.
 *
 * Single source of truth for the three writers of this column: the HTTP route
 * (`PATCH /api/cabinet-members/voice-transcription-prompt`), the agent tool
 * (`set_voice_transcription_prompt`) and the Web editor. Hard-coding `6000`
 * again anywhere would let one writer accept a value another one rejects —
 * the lawyer would then see a prompt saved by the agent that the Settings
 * screen refuses to re-save.
 */
export const VOICE_TRANSCRIPTION_PROMPT_MAX_CHARS = 6000;

/**
 * Body accepted by the personal voice transcription settings endpoint.
 *
 * A null value explicitly clears the membership override. The route also
 * normalizes a whitespace-only value (trimmed here to '') to the same reset.
 */
export const VoiceTranscriptionPromptPayloadSchema = z.object({
  prompt: z.string().trim().max(VOICE_TRANSCRIPTION_PROMPT_MAX_CHARS).nullable(),
});

export type VoiceTranscriptionPromptPayload = z.infer<
  typeof VoiceTranscriptionPromptPayloadSchema
>;

/** Response returned when loading a member's personal transcription prompt. */
export const VoiceTranscriptionPromptResponseSchema = z.object({
  defaultPrompt: z.string(),
  customPrompt: z.string().nullable(),
  maxCharacters: z.literal(VOICE_TRANSCRIPTION_PROMPT_MAX_CHARS),
});

export type VoiceTranscriptionPromptResponse = z.infer<
  typeof VoiceTranscriptionPromptResponseSchema
>;
